export default __webpack_public_path__ + "static/media/mixology-mobile-pattern.e55f6687.png";